<template>
  <v-container fluid>
      <Table_Dimensoes v-if="getSession.user.super == 1"/>
  </v-container>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getSession: "session/getState"
    })
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dimensoes.vue